import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import IndexController from 'cio/pods/broadcasts/newsletter/setup/tracking/index/controller';
import NewsletterModel from 'cio/models/newsletter';
import { ConversionTimeframe } from 'cio/utils/conversions';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class IndexRoute extends Route {
  @service store!: DS.Store;
  @service confirmChanges!: ConfirmChangesService;

  model() {
    return this.store.findRecord(
      'newsletter',
      (this.paramsFor('broadcasts.newsletter') as Record<string, any>).newsletter_id,
    );
  }

  afterModel() {
    return this.store.findAll('short-segment');
  }

  setupController(controller: IndexController, model: NewsletterModel, transition: Transition) {
    super.setupController(controller, model, transition);

    // if a conversion is set, and the conversion window is "all time", then we should show the dropdown so they can go
    // go back and forth for backwards compatibility
    if (model.conversion && model.conversionWindow === 0) {
      controller.setProperties({
        allowAnyTimeframe: true,
        selectedTimeframeType: ConversionTimeframe.AnyTime,
      });
    }

    // if an existing campaign has a conversion timeframe set to more than 90 days, don't show a validation error
    if (model.conversion && model.conversionWindow > controller.maxTimeframe) {
      controller.set('maxTimeframe', model.conversionWindow);
    }

    controller.createGroupCondition(model.conversionEventFilters);

    this.confirmChanges.register(controller, this);
  }
}
